import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { PromoDialog } from '@shared/components/promo-dialog/promo-dialog.component';
import { BasicModule } from '@shared/modules/basic.module';

@NgModule({
  imports: [BasicModule, CommonModule, RouterModule, MatIconModule, MatButtonModule, MatDialogModule],
  declarations: [PromoDialog],
  exports: [PromoDialog],
})
export class PromoDialogModule {}
